import React, { useEffect } from "react";
import { Notification } from "../common/Notification";
import * as httpClient from "../../util/httpClient";
import { ItransactionData } from "../../store/transaction/types";
interface IProps {
    transaction: ItransactionData;
    closeDialog: any;
    isNotMine: boolean;
}
const TransactionNotMineDialog: React.FunctionComponent<IProps> = (props) => {
    useEffect(() => {
        const cancelBtn: any = document.getElementById("btn-cancel-transaction-not-mine");
        cancelBtn.addEventListener("click", () => props.closeDialog("cancel"));
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog("cancel");
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const markTransactionAsNotMine = (value: boolean) => {
        const requestBody = {
            "transaction-id": props.transaction["transaction-id"],
            "fraudulent-charge": value,
        };

        httpClient
            .sendRequest("POST", `api/financial-account/minenotmine`, requestBody)
            .then((data) => {
                Notification({
                    type: "success",
                    title: value ? "Mark Transaction as Not Mine" : "Mark Transaction as Mine",
                    message: value ? "Mark transaction as not mine successful." : "Mark transaction as mine successful.",
                    duration: 5,
                });
                props.closeDialog("close");
            })
            .catch(function (error) {
                Notification({
                    type: "error",
                    title: value ? "Mark Transaction as Not Mine" : "Mark Transaction as Mine",
                    message: value ? "Mark transaction as not mine failed, please try again later." : "Mark transaction as mine failed, please try again later.",
                    duration: 5,
                });
            });
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                {props.isNotMine === true ? (
                    <React.Fragment>
                        <div className="dialog-icon status-red">
                            {" "}
                            <em className="las la-thumbs-down"></em>{" "}
                        </div>
                        <h1>Mark Transaction as Not Mine</h1>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div className="dialog-icon status-green">
                            <em className="las la-thumbs-up"></em>
                        </div>
                        <h1>Mark Transaction as Mine</h1>
                    </React.Fragment>
                )}
            </div>
            <div className="dialog-body">
                {props.isNotMine === true ? (
                    <React.Fragment>
                        <p>If you do not recognize this transaction, please click the 'Not Mine' button and follow the instructions below:</p>
                        <p>
                            1. Contact your financial institution to dispute the transaction. They should help identify if fraud has occurred and help resolve the
                            issue.
                        </p>
                        <p>
                            2. Make sure to tell the representative you are calling about account{" "}
                            {props.transaction["account-nickname"] != null ? props.transaction["account-nickname"] : props.transaction["account-name"]}
                        </p>
                        <p>
                            3. Explain the transaction for {"$ " + props.transaction["amount"]} on {props.transaction["transaction-date"]} is not valid.
                        </p>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <p>If you no longer believe this transaction is fraudulent, please click the 'Mine' button and follow the instructions below:</p>
                        <p>1. Contact your financial institution about this transaction.</p>
                        <p>
                            2. Make sure to tell the representative you are calling about account{" "}
                            {props.transaction["account-nickname"] != null ? props.transaction["account-nickname"] : props.transaction["account-name"]}
                        </p>
                        <p>
                            3. Explain the transaction for {"$ " + props.transaction["amount"]} on {props.transaction["transaction-date"]} is longer in need of
                            investigation.
                        </p>
                    </React.Fragment>
                )}
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" id="btn-cancel-transaction-not-mine">
                            <span className="btn-text">Cancel</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        {props.isNotMine === true ? (
                            <button
                                type="button"
                                className="btn-default btn-primary"
                                onClick={() => {
                                    markTransactionAsNotMine(true);
                                    window.addToDataLayer({ event: "Complete Transaction as Not Mine" });
                                }}
                                id="btn-submit-transaction-not-mine"
                            >
                                <span className="btn-text">Not Mine</span>
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn-default btn-primary"
                                onClick={() => {
                                    markTransactionAsNotMine(false);
                                    window.addToDataLayer({ event: "Complete Transaction as Mine" });
                                }}
                                id="btn-submit-transaction-mine"
                            >
                                <span className="btn-text">Mine</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default TransactionNotMineDialog;
